import React from 'react';
import PropTypes from 'prop-types';
import {
  Spacer,
  Label,
  Checkbox,
  Visible,
} from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import { PLATES_FOR_POOLING } from 'src/constants/forms';
import messages from '../../../messages';

const PlatesForPooling = ({
  showPlatesForPooling,
  showPoolingScrollBar,
  checkedPoolingPlates,
  platesForPooling,
  onCheckPlates
}) => (
  <div>
    <Label>
      <Message message={messages.poolingPlates} />
    </Label>
    <div className={`pooling-wrapper ${showPoolingScrollBar ? '--show-scroll' : ''}`}>
      <Visible when={showPlatesForPooling}>
        {platesForPooling?.map((item, index) => (
          <div key={item.plateName}>
            <Checkbox
              onChange={() => onCheckPlates(index, PLATES_FOR_POOLING)}
              checked={checkedPoolingPlates.includes(index)}
              disabled={
                !checkedPoolingPlates.includes(index) &&
                            checkedPoolingPlates.length > 1
              }
              inline
            >
              {item.plateName}
            </Checkbox>
            <Spacer bottom={8} />
          </div>
        ))}
      </Visible>
    </div>
  </div>
);

PlatesForPooling.propTypes = {
  showPlatesForPooling: PropTypes.bool.isRequired,
  showPoolingScrollBar: PropTypes.bool.isRequired,
  checkedPoolingPlates: PropTypes.array.isRequired,
  platesForPooling: PropTypes.array.isRequired,
  onCheckPlates: PropTypes.func.isRequired
};

export default PlatesForPooling;
